export const NotFound = () => {
  return <h1>Not Found</h1>;
};
